import { navigateToBaseRoute } from "@/utils/route-utility";
import type { ItsOneViewLink } from "@/types/its-one-view";

export function openItsOneViewLink(link: ItsOneViewLink): void {
  navigateToBaseRoute(link.baseRoute, link.routeId ?? null, link.hashPaths);
}
